export default __webpack_public_path__ + "static/featured-image-ed4702750566a5cd24c89a7fb60a70f4.jpg";